/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Specific_PageInputs */

const en_common_specific_page = /** @type {(inputs: Common_Specific_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specific page`)
};

const es_common_specific_page = /** @type {(inputs: Common_Specific_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página específica`)
};

/**
* | output |
* | --- |
* | "Specific page" |
*
* @param {Common_Specific_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_specific_page = /** @type {((inputs?: Common_Specific_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Specific_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_specific_page(inputs)
	return en_common_specific_page(inputs)
});